import { KalTableSortEvent } from 'src/app/_shared/modules/kal-table/classes/managers/kal-table-sort-manager';
import {
    ColumnFilterListChoice,
    ColumnFilterType
} from 'src/app/_shared/modules/kal-table/kal-table-header/kal-table-header.component';

export class KalTableHeader<T = any> {
    id?: string;

    code: keyof T;

    label?: any;

    sortable?: boolean;

    sticky?: boolean;

    stickyEnd?: boolean;

    columnFilterType?: ColumnFilterType;

    columnFilterList?: ColumnFilterListChoice[];

    dynamicColumnFilterList?: ColumnFilterListChoice[];

    /**
     * formatteur de la donnée pour l'export
     */
    exporter?: (row: T, code: keyof T) => string;

    /**
     * comparateur spécifique pour les cas où on ne peut pas trier seulement en fonction du code
     */
    customComparator?: (sort: KalTableSortEvent) => (a: T, b: T) => number;
}
